<template>
  <div class="jd-cover">
    <div v-if="employmentType" class="jd-cover__tags">
      <emp-type :name="employmentType" />
    </div>
    <div class="jd-cover__text">
      <h2 v-if="companyName" class="jd-cover__company-name">{{ companyName }}</h2>
      <h1 class="jd-cover__name">{{ jobName }}</h1>
    </div>
    <jc-logo :name="companyName" :src="companyLogo" />
  </div>
</template>

<script>
import CompanyMixin from '../../../mixins/company'
import EmpType from '../../employmentType'
import JobCompanyLogo from '../jobCompany/jobCompanyLogo'

export default {
  components: {
    'emp-type': EmpType,
    'jc-logo': JobCompanyLogo,
  },
  mixins: [CompanyMixin],
  props: {
    employmentType: {
      required: true,
      type: String,
    },
    jobName: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.jd-cover {
  @apply flex flex-wrap;
}
.jd-cover__tags {
  @apply w-full mb-2 text-sm;
}
.jd-cover__text {
  @apply flex-1;
}
.jc-logo {
  @apply ml-3;
  width: 76px;
  height: 76px;
}
.jd-cover__company-name {
  @apply text-sm font-normal;
  margin: 0 !important;
}

h1 {
  @apply text-ch4 font-ch4;
}

@screen desktop {
  .jd-cover__tags {
    @apply mt-1 mb-4 text-base;
  }
  .emp-type {
    @apply text-base;
  }
  h1 {
    @apply text-ch3 font-ch3;
    @apply leading-normal;
  }
  .jc-logo {
    @apply ml-4;
    width: 80px;
    height: 80px;
  }
  /** hardcode to override the style and make the company name
  be H2 for SEO purpose and retain the original style **/
  .jd-cover__company-name {
    font-size: 1.0625rem !important;
    font-weight: normal !important;
    margin: 0 !important;
  }
}
</style>
